import { render } from "./NutritionFacts.vue?vue&type=template&id=4e67b6d0&scoped=true"
import script from "./NutritionFacts.vue?vue&type=script&lang=js"
export * from "./NutritionFacts.vue?vue&type=script&lang=js"

import "./NutritionFacts.vue?vue&type=style&index=0&id=4e67b6d0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e67b6d0"],['__file',"resources/js/modules/labelinsight-products/components/NutritionFacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e67b6d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e67b6d0', __exports__)) {
    api.reload('4e67b6d0', __exports__)
  }
  
  module.hot.accept("./NutritionFacts.vue?vue&type=template&id=4e67b6d0&scoped=true", () => {
    api.rerender('4e67b6d0', render)
  })

}


export default __exports__